export * from "./WideCard";
